// TalesLore — Mythology catalog with MULTIPLE deities per tradition.
// Each deity has an emoji, a short respectful blurb, and a canonical name used in
// the Claude prompt. The deity is always portrayed with dignity and honor.

export const MYTHOLOGIES = [
  {
    key: 'Hindu',
    flag: '🛕',
    tagline: 'Ancient tales of dharma, courage and cosmic wonder',
    deities: [
      { name: 'Ganesha',   emoji: '🐘', blurb: 'Wise remover of obstacles' },
      { name: 'Krishna',   emoji: '🪩', blurb: 'Playful guide, protector of friends' },
      { name: 'Hanuman',   emoji: '💪', blurb: 'Devoted, mighty and fearless' },
      { name: 'Durga',     emoji: '🌺', blurb: 'Fierce, brave and protecting' },
      { name: 'Saraswati', emoji: '🎶', blurb: 'Goddess of wisdom, music and learning' },
      { name: 'Shiva',     emoji: '🌙', blurb: 'Calm, powerful, transformer of worlds' },
      { name: 'Lakshmi',   emoji: '🪙', blurb: 'Bringer of grace, prosperity and light' },
      { name: 'Rama',      emoji: '🏹', blurb: 'Noble, honorable and steadfast' },
    ],
  },
  {
    key: 'Greek',
    flag: '🏹',
    tagline: 'Legends from Mount Olympus and the Aegean sea',
    deities: [
      { name: 'Athena',     emoji: '🦉', blurb: 'Wise strategist and guide of courage' },
      { name: 'Poseidon',   emoji: '🌊', blurb: 'Noble ruler of the seas' },
      { name: 'Apollo',     emoji: '☀️', blurb: 'Radiant of music, healing and light' },
      { name: 'Artemis',    emoji: '🌙', blurb: 'Graceful protector of the wild' },
      { name: 'Hermes',     emoji: '👟', blurb: 'Swift messenger and clever helper' },
      { name: 'Zeus',       emoji: '⚡', blurb: 'Majestic ruler of the skies' },
      { name: 'Hephaestus', emoji: '🔨', blurb: 'Master craftsman and inventor of wonders' },
    ],
  },
  {
    key: 'Norse',
    flag: '⚡',
    tagline: 'Sagas of the frost lands and the world tree',
    deities: [
      { name: 'Thor',   emoji: '🔨', blurb: 'Mighty and brave protector' },
      { name: 'Odin',   emoji: '🦉', blurb: 'Wise all-seeing sage' },
      { name: 'Freya',  emoji: '🌸', blurb: 'Graceful goddess of love and courage' },
      { name: 'Baldur', emoji: '🌟', blurb: 'Radiant, kind and beloved' },
      { name: 'Tyr',    emoji: '⚔️', blurb: 'Honorable, just and steadfast' },
    ],
  },
  {
    key: 'Egyptian',
    flag: '👁️',
    tagline: 'Stories from the Nile and the golden sands',
    deities: [
      { name: 'Ra',     emoji: '☀️', blurb: 'Radiant creator of the sun' },
      { name: 'Isis',   emoji: '🩽', blurb: 'Loving, wise and protecting mother' },
      { name: 'Horus',  emoji: '🦅', blurb: 'Noble falcon guardian of kings' },
      { name: 'Thoth',  emoji: '📜', blurb: 'Keeper of writing and wisdom' },
      { name: 'Bastet', emoji: '🐈', blurb: 'Warm protector of home and joy' },
      { name: 'Osiris', emoji: '🌿', blurb: 'Kind, dignified lord of renewal' },
    ],
  },
  {
    key: 'Japanese',
    flag: '🌸',
    tagline: 'Tales of the sun, sea, and sacred mountains',
    deities: [
      { name: 'Amaterasu', emoji: '☀️', blurb: 'Radiant sun goddess of warmth' },
      { name: 'Susanoo',   emoji: '🌀', blurb: 'Brave, spirited protector of storms' },
      { name: 'Inari',     emoji: '🦊', blurb: 'Kind guardian of harvest and fortune' },
      { name: 'Benzaiten', emoji: '🎶', blurb: 'Graceful patron of music and wisdom' },
    ],
  },
  {
    key: 'Chinese',
    flag: '🐉',
    tagline: 'Legends of celestial mountains and jade palaces',
    deities: [
      { name: 'Sun Wukong', emoji: '🐒', blurb: 'Clever, courageous and loyal hero' },
      { name: "Chang'e",    emoji: '🌕', blurb: 'Serene, graceful lunar goddess' },
      { name: 'Nu Wa',      emoji: '🐲', blurb: 'Wise, creative mother of life' },
      { name: 'Nezha',      emoji: '🔥', blurb: 'Brave, spirited young warrior' },
    ],
  },
  {
    key: 'Celtic',
    flag: '🍀',
    tagline: 'Whispers of the mist, the oak and the hearth',
    deities: [
      { name: 'Brigid',    emoji: '🔥', blurb: 'Warm goddess of hearth and poetry' },
      { name: 'Lugh',      emoji: '🌞', blurb: 'Skilled, radiant patron of many arts' },
      { name: 'Cernunnos', emoji: '🦌', blurb: 'Gentle guardian of forests and creatures' },
    ],
  },
  {
    key: 'Polynesian',
    flag: '🌴',
    tagline: 'Voyages across the wide, sparkling Pacific',
    deities: [
      { name: 'Maui',     emoji: '🎣', blurb: 'Clever, brave hero of the isles' },
      { name: 'Pele',     emoji: '🌋', blurb: 'Powerful, passionate keeper of fire' },
      { name: 'Tangaroa', emoji: '🌊', blurb: 'Noble ruler of the great ocean' },
    ],
  },
  {
    key: 'Aztec',
    flag: '🐍',
    tagline: 'Chronicles of jade cities and feathered serpents',
    deities: [
      { name: 'Quetzalcoatl', emoji: '🦎', blurb: 'Wise, kind feathered serpent of learning' },
      { name: 'Tlaloc',       emoji: '🌧️', blurb: 'Gentle bringer of rain and green fields' },
    ],
  },
  {
    key: 'African/Yoruba',
    flag: '🥁',
    tagline: 'Wisdom tales from the great continent',
    deities: [
      { name: 'Anansi', emoji: '🕷️', blurb: 'Clever, warm storyteller and teacher' },
      { name: 'Shango', emoji: '⚡', blurb: 'Noble, brave king of thunder' },
      { name: 'Oya',    emoji: '🌪️', blurb: 'Powerful, graceful spirit of winds' },
    ],
  },
  {
    key: 'Roman',
    flag: '🏰',
    tagline: 'Epic tales from the seven hills',
    deities: [
      { name: 'Minerva',  emoji: '🦉', blurb: 'Wise patron of learning and courage' },
      { name: 'Neptune',  emoji: '🌊', blurb: 'Noble ruler of the seas' },
      { name: 'Diana',    emoji: '🌙', blurb: 'Graceful protector of moon and wild' },
      { name: 'Mercury',  emoji: '👟', blurb: 'Swift, clever guide and messenger' },
    ],
  },
];

// Convenience lookup by mythology key
export function getMythology(key) {
  return MYTHOLOGIES.find((m) => m.key === key) || null;
}

export function getDeity(mythologyKey, deityName) {
  const m = getMythology(mythologyKey);
  if (!m) return null;
  return m.deities.find((d) => d.name === deityName) || null;
}

export const INTERESTS = [
  'Football', 'Dinosaurs', 'Butterflies', 'Space',
  'Cooking', 'Painting', 'Animals', 'Cars',
  'Music', 'Dancing', 'Books', 'Science',
  'Swimming', 'Chess', 'Drawing', 'Gardening',
];

// Full language catalog with English + native display names, grouped by region.
// The `name` field is what we pass to Claude (English label). The `native` is
// shown alongside in the UI so parents can find their language easily.
export const LANGUAGE_GROUPS = [
  {
    region: 'Indian languages',
    languages: [
      { name: 'Hindi',      native: 'हिन्दी' },
      { name: 'Gujarati',   native: 'ગુજરાતી' },
      { name: 'Tamil',      native: 'தமிழ்' },
      { name: 'Telugu',     native: 'తెలుగు' },
      { name: 'Marathi',    native: 'मराठी' },
      { name: 'Bengali',    native: 'বাংলা' },
      { name: 'Kannada',    native: 'ಕನ್ನಡ' },
      { name: 'Malayalam',  native: 'മലയാളം' },
      { name: 'Punjabi',    native: 'ਪੰਜਾਬੀ' },
      { name: 'Odia',       native: 'ଓଡ଼ିଆ' },
      { name: 'Urdu',       native: 'اردو' },
    ],
  },
  {
    region: 'European',
    languages: [
      { name: 'English',    native: 'English' },
      { name: 'Spanish',    native: 'Español' },
      { name: 'Portuguese', native: 'Português' },
      { name: 'French',     native: 'Français' },
      { name: 'German',     native: 'Deutsch' },
      { name: 'Italian',    native: 'Italiano' },
      { name: 'Dutch',      native: 'Nederlands' },
      { name: 'Swedish',    native: 'Svenska' },
      { name: 'Norwegian',  native: 'Norsk' },
      { name: 'Danish',     native: 'Dansk' },
      { name: 'Finnish',    native: 'Suomi' },
      { name: 'Polish',     native: 'Polski' },
      { name: 'Czech',      native: 'Čeština' },
      { name: 'Hungarian',  native: 'Magyar' },
      { name: 'Romanian',   native: 'Română' },
      { name: 'Bulgarian',  native: 'Български' },
      { name: 'Greek',      native: 'Ελληνικά' },
      { name: 'Russian',    native: 'Русский' },
    ],
  },
  {
    region: 'Middle East & Asia',
    languages: [
      { name: 'Arabic',              native: 'العربية' },
      { name: 'Hebrew',              native: 'עברית' },
      { name: 'Turkish',             native: 'Türkçe' },
      { name: 'Persian',             native: 'فارسی' },
      { name: 'Indonesian',          native: 'Bahasa Indonesia' },
      { name: 'Malay',               native: 'Bahasa Melayu' },
      { name: 'Thai',                native: 'ไทย' },
      { name: 'Vietnamese',          native: 'Tiếng Việt' },
      { name: 'Filipino',            native: 'Filipino' },
      { name: 'Japanese',            native: '日本語' },
      { name: 'Korean',              native: '한국어' },
      { name: 'Chinese Simplified',  native: '简体中文' },
      { name: 'Chinese Traditional', native: '繁體中文' },
    ],
  },
  {
    region: 'African',
    languages: [
      { name: 'Swahili',   native: 'Kiswahili' },
      { name: 'Afrikaans', native: 'Afrikaans' },
    ],
  },
];

// Flat list of language names (used for validation + default)
export const LANGUAGES = LANGUAGE_GROUPS.flatMap((g) => g.languages.map((l) => l.name));

// Lookup helper: given the English name, return { name, native } or null.
export function getLanguage(name) {
  for (const g of LANGUAGE_GROUPS) {
    const match = g.languages.find((l) => l.name === name);
    if (match) return match;
  }
  return null;
}

export const AGE_GROUPS = ['3–5 years', '5–7 years', '8–10 years', '11–12 years'];
export const GENDERS = [
  { key: 'boy', label: 'Boy (he/him)' },
  { key: 'girl', label: 'Girl (she/her)' },
];
export const STORY_LENGTHS = [
  { key: 'short',    label: 'Short (3 min read — ~550 words)',    words: 550 },
  { key: 'standard', label: 'Standard (7 min read — ~1000 words)', words: 1000 },
  { key: 'long',     label: 'Long (12 min read — ~1600 words)',    words: 1600 },
];
